<template>
    <div class="customer_home sitePSM_container">
      <div class="main_table">
        <div class="Item__btn_container"  >
          <div class="search_item">
            <svg class="icon" style="margin-right:8px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8184 21.9373L17.4468 16.5678C18.8966 14.9157 19.7777 12.7519 19.7777 10.3857C19.7777 5.21029 15.5653 1 10.3888 1C5.21133 0.998962 1 5.21029 1 10.3847C1 15.5591 5.21237 19.7704 10.3888 19.7704C12.7519 19.7704 14.9136 18.8924 16.5657 17.4468L21.9383 22.8174C22.0598 22.9398 22.2196 23 22.3784 23C22.5382 23 22.697 22.9388 22.8184 22.8174C23.0623 22.5745 23.0623 22.1802 22.8184 21.9373ZM10.3889 18.5251C5.89836 18.5251 2.24536 14.8731 2.24536 10.3847C2.24536 5.89626 5.89836 2.24429 10.3889 2.24429C14.8794 2.24429 18.5324 5.89626 18.5324 10.3847C18.5324 14.8731 14.8794 18.5251 10.3889 18.5251Z" fill="gray"/>
            </svg>
            <div ><input type="text" class="input_select" placeholder="Search Secure SN" v-model='searchItem'></div>
          </div>
          <md-button class="md-raised md-primary btn_customer" @click="showAdd" v-if="enableAdd"> <md-icon class="md-size-2x">add</md-icon>Add</md-button>
        </div>
        <md-table v-model="listPSM" md-card style="max-height:750px">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell  md-label="EmpID" >{{ item.empID }}</md-table-cell>
            <md-table-cell  md-label="Name" >{{ item.name }}</md-table-cell>
            <md-table-cell md-label="Dept" >{{ item.dept }}</md-table-cell>
            <md-table-cell md-label="AO1" >{{ item.ao1 }}</md-table-cell>
            <md-table-cell md-label="AO2" >{{ item.ao2 }}</md-table-cell>
            <md-table-cell md-label="Security SN" >{{ item.psm_id }}</md-table-cell>
            <md-table-cell md-label="Purpose" >{{ item.purpose }}</md-table-cell>
            <md-table-cell md-label="Source"  >{{ item.source }}</md-table-cell>
            <md-table-cell md-label="Destination"  >{{ item.destination }}</md-table-cell>
            <md-table-cell md-label="Files Transferred"  >{{ item.file_transferred }}</md-table-cell>
            <md-table-cell md-label="Status"  >
              <div :style="{color:item.color,fontWeight:'bold'}">
                {{item.status}}
                <span @click="showStartJob(item)" style="cursor: pointer;margin-left: 6px;" v-if="item.status==='Draft'">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  
                  <g clip-path="url(#clip0_4964_1276)">
                  <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#10C558" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_4964_1276">
                  <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </span>
                <span @click="showCancleJob(item)" style="cursor: pointer;margin-left: 6px;" v-if="item.status==='In process'">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#6D6E71" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </md-table-cell>
            <md-table-cell md-label="Updated"  >{{ convertTime(item.updatedAt) }}</md-table-cell>
            <md-table-cell md-label="Edit">
                <md-menu md-size="medium" md-align-trigger>
                <md-button md-menu-trigger><md-icon>more_horiz</md-icon></md-button>
                <md-menu-content v-if="item.status==='Draft'">
                    <md-menu-item @click="showUpdate(item)">Update</md-menu-item>
                    <md-menu-item @click="showDelete(item)"><div style="color:red">Delete</div></md-menu-item>
                </md-menu-content>
                </md-menu>
            </md-table-cell>
            </md-table-row>
        </md-table>
      </div>
       <Pagination  class="table_pagination" v-if='pagiShow'
            v-model="currentPage" 
            :page-count="totalPages"
            @change="onChange"
        />
      <md-dialog :md-active.sync="delete_active" class="custom_dialog_container">
          <md-dialog-title >
            <label class='lb_close' @click="delete_active=false"><md-icon class="icon_close">clear</md-icon></label>
            <label class='lb-title'>Delete PSM Loan Request</label>
          </md-dialog-title>
          <md-dialog-content>
            <span>Do you want to delete this PSM loan request?</span>
            <br>
            <span>All related data will alse be deleted.</span>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button class="md-raised" @click="delete_active = false">Cancel</md-button>
            <md-button class="md-raised md-accent" @click="handleDeleteItem">Delete</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="startjob_active" class="custom_dialog_container">
          <md-dialog-title >
            <label class='lb_close' @click="handleStartClose"><md-icon class="icon_close">clear</md-icon></label>
            <label class='lb-title'>Submit Request</label>
          </md-dialog-title>
          <md-dialog-content>
            <span>Are you sure you want to submit this request?</span>
            <br>
            <md-progress-spinner  v-if="loading" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button class="md-raised" @click="handleStartClose">No</md-button>
            <md-button class="md-raised md-primary" @click="handleChangeStatus">Yes</md-button>
        </md-dialog-actions>
      </md-dialog>


      <md-dialog :md-active.sync="canceljob_active" class="custom_dialog_container">
          <md-dialog-title >
            <label class='lb_close' @click="handleCancleClose"><md-icon class="icon_close">clear</md-icon></label>
            <label class='lb-title'>Cancel this job</label>
          </md-dialog-title>
          <md-dialog-content>
            <span>Are you sure you want to cancel this job?</span>
            <br>
            <md-progress-spinner  v-if="loading" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </md-dialog-content>
          <md-dialog-actions>
            <md-button class="md-raised" @click="handleCancleClose">No</md-button>
            <md-button class="md-raised md-accent" @click="handleChangeStatus">Yes</md-button>
        </md-dialog-actions>
      </md-dialog>


  
      <md-dialog :md-active.sync="update_active" class="dialog_updateSite custom_dialog_container">
        <md-dialog-title >
          <label class='lb_close' @click="update_active=false;ao_selected={};item_selected={};list_ao_show=false;list_item_show=false"><md-icon class="icon_close">clear</md-icon></label>
          <label class='lb-title'>Update PSM Loan Request</label>
        </md-dialog-title>
        <md-dialog-content>
        <form class="dialog_update__texts" ref="updatePSMForm">
          <div class="header_form">Employee</div>
          <div class="multi_input">
            <div class="custom_input" style="width:48%">
              <input type="text" placeholder="EmpID" :value="userInfo.emNum" required readonly>
              <label>EmpID*</label>
            </div>
  
            <div class="custom_input" style="width:48%">
              <input type="text"  placeholder="Name" :value="userInfo.name" required readonly>
              <label>Name*</label>
            </div>
          </div>
          <div class="custom_input" >
            <input type="text"  placeholder="Dept" :value="userInfo.dept" readonly>
            <label>Dept</label>
          </div>

          <div class="header_form">AO Information</div>
          <div class="multi_input">
            <div class="dialog_update__selects" style="width:100%">
                <div class="dialog_update__select">
                  <div class="system_lists" v-if="list_ao_show" >
                    <li v-for="(ao, index) in currentSiteAO" :key="index" @click="selectAO(ao)">
                      <div >{{ao.name}}</div>
                    </li>
                  </div>
                  <md-icon class="icon">keyboard_arrow_down</md-icon>
                  <div @click="list_ao_show=!list_ao_show"><input type="text" class="input_select" placeholder="EmpID" readonly v-model="ao_selected.emNum" required></div>
                  <label :style="{color:list_ao_show?'#0080F6':'#6D6E71'}">
                    AO1 EmpID*
                  </label>
                </div>
            </div>
  
            <!-- <div class="custom_input" style="width:48%">
              <input type="text" placeholder="Name" v-model="ao_selected.name" required readonly>
              <label>AO1 Name*</label>
            </div> -->
          </div>
          
          <div class="multi_input">
            <div class="custom_input" style="width:48%">
              <input type="text" placeholder="EmpID" v-model="ao_selected.ao2_emNum" required readonly>
              <label>AO2 EmpID*</label>
            </div>
  
            <div class="custom_input" style="width:48%">
              <input type="text"  placeholder="Name" v-model="ao_selected.ao2_name" readonly required>
              <label>AO2 Name*</label>
            </div>
          </div>
          <div class="header_form">PSM ID</div>
          <div class="multi_input">
            <div class="dialog_update__selects" style="width:48%">
                <div class="dialog_update__select">
                  <div class="system_lists" v-if="list_item_show" >
                    <li v-for="(item, index) in listItem" :key="index" @click="selectItem(item)">
                      <div >{{item.secureSN}}</div>
                    </li>
                  </div>
                  <md-icon class="icon">keyboard_arrow_down</md-icon>
                  <div @click="list_item_show=!list_item_show"><input type="text" class="input_select" placeholder="" readonly v-model="item_selected.secureSN" required></div>
                  <label :style="{color:list_item_show?'#0080F6':'#6D6E71'}">
                    Securiry SN*
                  </label>
                </div>
            </div>
  
            <div class="custom_input" style="width:48%">
              <input type="text" placeholder="Input data" v-model="tempPSM.inputData" required>
              <label>Input data*</label>
            </div>
          </div>
        
          

          <div class="custom_input">
            <input type="text"  placeholder="Purpose" v-model="tempPSM.purpose" required>
            <label>Purpose*</label>
          </div>
          <div class="custom_input">
            <input type="text"  placeholder="Source" v-model="tempPSM.source">
            <label>Source</label>
          </div>
          <div class="custom_input">
            <input type="text"  placeholder="Destination" v-model="tempPSM.destination">
            <label>Destination</label>
          </div>
          <div class="custom_input">
            <textarea placeholder="File Transferred" v-model="tempPSM.file_transferred"></textarea>
            <label>File Transferred</label>
          </div>
          <div class="header_alert">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.617 3.47166L17.4045 15.3636C17.4671 15.4731 17.5 15.5974 17.5 15.7239C17.5 15.8504 17.4671 15.9747 17.4045 16.0843C17.342 16.1939 17.2521 16.2848 17.1438 16.3481C17.0354 16.4114 16.9126 16.4447 16.7875 16.4447H3.2125C3.08743 16.4447 2.96456 16.4114 2.85625 16.3481C2.74794 16.2848 2.65799 16.1939 2.59546 16.0843C2.53292 15.9747 2.5 15.8504 2.5 15.7239C2.5 15.5974 2.53292 15.4731 2.59546 15.3636L9.38295 3.47166C9.44549 3.3621 9.53544 3.27113 9.64375 3.20788C9.75207 3.14463 9.87493 3.11133 10 3.11133C10.1251 3.11133 10.2479 3.14463 10.3562 3.20788C10.4646 3.27113 10.5545 3.3621 10.617 3.47166ZM9.28748 12.841V14.2825H10.7125V12.841H9.28748ZM9.28748 7.79599V11.3996H10.7125V7.79599H9.28748Z" fill="#F27B2C"/>
            </svg>
            Please do not enter any classified or sensitive information
          </div>
        </form>
        </md-dialog-content>
      
        <md-dialog-actions>
          <md-button class="md-raised" @click="update_active=false;ao_selected={};item_selected={};list_ao_show=false;list_item_show=false">Cancel</md-button>
          <md-button class="md-raised md-primary" @click="handleUpdateItem">Save</md-button>
        </md-dialog-actions>
      </md-dialog>
  
  
      <md-dialog :md-active.sync="add_active" class="dialog_updateSite custom_dialog_container">
        <md-dialog-title >
          <label class='lb_close' @click="add_active=false;ao_selected={};item_selected={};list_ao_show=false;list_item_show=false"><md-icon class="icon_close">clear</md-icon></label>
          <label class='lb-title'>Add PSM Loan Request</label>
        </md-dialog-title>
        <md-dialog-content>
        <form class="dialog_update__texts" ref="addPSMForm">
          <div class="header_form">Employee</div>
          <div class="multi_input">
            <div class="custom_input" style="width:48%">
              <input type="text" placeholder="EmpID" :value="userInfo.emNum" required readonly>
              <label>EmpID*</label>
            </div>
  
            <div class="custom_input" style="width:48%">
              <input type="text"  placeholder="Name" :value="userInfo.name" required readonly>
              <label>Name*</label>
            </div>
          </div>
          <div class="custom_input" >
            <input type="text"  placeholder="Dept" :value="userInfo.dept" readonly>
            <label>Dept</label>
          </div>

          <div class="header_form">AO Information</div>
          <div class="multi_input">
            <div class="dialog_update__selects" style="width:48%">
                <div class="dialog_update__select">
                  <div class="system_lists" v-if="list_ao_show" >
                    <li v-for="(ao, index) in currentSiteAO" :key="index" @click="selectAO(ao)">
                      <div >{{ao.name}}</div>
                    </li>
                  </div>
                  <md-icon class="icon">keyboard_arrow_down</md-icon>
                  <div @click="list_ao_show=!list_ao_show"><input type="text" class="input_select" placeholder="EmpID" readonly v-model="ao_selected.emNum" required></div>
                  <label :style="{color:list_ao_show?'#0080F6':'#6D6E71'}">
                    AO1 EmpID*
                  </label>
                </div>
            </div>
  
            <div class="custom_input" style="width:48%">
              <input type="text" placeholder="Name" v-model="ao_selected.name" required readonly>
              <label>AO1 Name*</label>
            </div>
          </div>
          
          <div class="multi_input">
            <div class="custom_input" style="width:48%">
              <input type="text" placeholder="EmpID" v-model="ao_selected.ao2_emNum" required readonly>
              <label>AO2 EmpID*</label>
            </div>
  
            <div class="custom_input" style="width:48%">
              <input type="text"  placeholder="Name" v-model="ao_selected.ao2_name" readonly required>
              <label>AO2 Name*</label>
            </div>
          </div>
          <div class="header_form">PSM ID</div>
          <div class="multi_input">
            <div class="dialog_update__selects" style="width:100%">
                <div class="dialog_update__select">
                  <div class="system_lists" v-if="list_item_show" >
                    <li v-for="(item, index) in listItem" :key="index" @click="selectItem(item)">
                      <div >{{item.secureSN}}</div>
                    </li>
                  </div>
                  <md-icon class="icon">keyboard_arrow_down</md-icon>
                  <div @click="list_item_show=!list_item_show"><input type="text" class="input_select" placeholder="" readonly v-model="item_selected.secureSN" required></div>
                  <label :style="{color:list_item_show?'#0080F6':'#6D6E71'}">
                    Security SN*
                  </label>
                </div>
            </div>
  
            <!-- <div class="custom_input" style="width:48%">
              <input type="text" placeholder="Input data" v-model="tempPSM.inputData" required>
              <label>Input data*</label>
            </div> -->
          </div>
        
          

          <div class="custom_input">
            <input type="text"  placeholder="Purpose" v-model="tempPSM.purpose" required>
            <label>Purpose*</label>
          </div>
          <div class="custom_input">
            <input type="text"  placeholder="Source" v-model="tempPSM.source">
            <label>Source</label>
          </div>
          <div class="custom_input">
            <input type="text"  placeholder="Destination" v-model="tempPSM.destination">
            <label>Destination</label>
          </div>
          <div class="custom_input">
            <textarea placeholder="File Transferred" v-model="tempPSM.file_transferred"></textarea>
            <label>File Transferred</label>
          </div>
          <div class="header_alert">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.617 3.47166L17.4045 15.3636C17.4671 15.4731 17.5 15.5974 17.5 15.7239C17.5 15.8504 17.4671 15.9747 17.4045 16.0843C17.342 16.1939 17.2521 16.2848 17.1438 16.3481C17.0354 16.4114 16.9126 16.4447 16.7875 16.4447H3.2125C3.08743 16.4447 2.96456 16.4114 2.85625 16.3481C2.74794 16.2848 2.65799 16.1939 2.59546 16.0843C2.53292 15.9747 2.5 15.8504 2.5 15.7239C2.5 15.5974 2.53292 15.4731 2.59546 15.3636L9.38295 3.47166C9.44549 3.3621 9.53544 3.27113 9.64375 3.20788C9.75207 3.14463 9.87493 3.11133 10 3.11133C10.1251 3.11133 10.2479 3.14463 10.3562 3.20788C10.4646 3.27113 10.5545 3.3621 10.617 3.47166ZM9.28748 12.841V14.2825H10.7125V12.841H9.28748ZM9.28748 7.79599V11.3996H10.7125V7.79599H9.28748Z" fill="#F27B2C"/>
            </svg>
            Please do not enter any classified or sensitive information
          </div>
        </form>
        </md-dialog-content>
      
        <md-dialog-actions>
          <md-button class="md-raised" @click="add_active=false;ao_selected={};item_selected={};list_ao_show=false;list_item_show=false">Cancel</md-button>
          <md-button class="md-raised md-primary" @click="handleAddItem">Add</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </template>
  <script>
  import request from '@/utils/request'
  import Pagination from '../../components/Pagination'
//   import resize from '@/utils/resize'
  // import {SERVER_HOSTNAME} from '../../utils/config'
  const getStatus=(data)=>{
    if(data.status==='-' && data.staff_status==='-' && data.ao_status==='-'){
      return{color:'#6D6E71',status:'Draft'}
    }
    if(data.status==='process' && data.staff_status==='-' && data.ao_status==='-'){
      return{color:'#EB9515',status:'In process'}
    }
    if(data.status==='finished'){
      return {color:'#0080F6',status:'Finished'}
    }
    if(data.staff_status==='0'){
      return {color:'black',status:'Canceled'}
    }
    if(data.staff_status!=='0'&&data.ao_status==='0'){
      return {color:'#ED1D24',status:'Rejected'}
    }
    if(data.staff_status!=='0'&&data.ao_status==='1'){
      return {color:'#00C14D',status:'Approved'}
    }
  }
  export default {
    name:'SitePSM',
    components:{
      Pagination
    },
    created() {
      // if(this.$store.state.info){
      //   this.userInfo=this.$store.state.info
      // }
      request('get', '/sites/' +this.siteId)
      .then(dt=>{
        this.siteInfo = dt.site
        console.log(this.siteInfo)
      })
      .catch(err => console.log(err))
      request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
        .then(data => {
          this.totalPages=data.pages
          this.userInfo=data.userInfo
          let newPSM=[]
          for(let pm of data.psm){
            let res= getStatus(pm)
            newPSM.push({
              ...pm,
              ...res,
              empID:this.userInfo?this.userInfo.emNum:'',
              name:this.userInfo?this.userInfo.name:'',
              dept:this.userInfo?this.userInfo.dept:''

            })
          }
          this.listPSM=newPSM
          // console.log(this.listPSM)
          
        })
        .catch(err => console.log(err))
        request('post',  `/users/ao?site=${this.siteId}`)
        .then(data => {
            let newList = data.users.filter(el=>el.ao2_id!=='')
            this.currentSiteAO = newList
        })
        .catch(err => {
            console.log(err)
            // alert(err.message)
        })
        request('post',  `/items/available?site=${this.siteId}`)
        .then(data => {
          this.listItem = data.items;
        })
        .catch(err => {
            console.log(err)
            // alert(err.message)
        })

    },
    data(){
      return{
        siteInfo:null,
        userInfo:{},
        currentPage: 1,
        totalPages:0,
        siteId: this.$route.params.id,
        update_active:false,
        delete_active:false,
        add_active:false,

        currentSiteAO:[],
        list_ao_show:false,
        ao_selected:{},

        listItem:[],
        list_item_show:false,
        item_selected:{},

        listPSM:[],

        startjob_active:false,
        canceljob_active:false,
        loading:false,




        items: [],
        tempPSM: {},
        searchItem:'',
        
  
  
      }
    },
    computed: {
      pagiShow() {
        if(this.totalPages>0) {
            return true;
        }
        return false;
      },
      enableAdd(){
        if(this.siteInfo){
          return !this.siteInfo.mode
        }
        return 0
      }
      // currentSiteItems() {
      //   return this.items.filter(item => {
      //     return item.site && (item.site == this.siteId || item.site._id == this.siteId)
      //   })
      // },
    },
    watch:{
      searchItem:function(){
        if(this.searchItem.length>=3){
          this.currentPage=1;
          request('post', `/pm-request/search/${this.currentPage}`,{query:this.searchItem,site:this.siteId})
          .then(data => {
            this.totalPages=data.pages
            this.userInfo=data.userInfo
            let newPSM=[]
            for(let pm of data.psm){
              let res= getStatus(pm)
              newPSM.push({
                ...pm,
                ...res,
                empID:this.userInfo?this.userInfo.emNum:'',
                name:this.userInfo?this.userInfo.name:'',
                dept:this.userInfo?this.userInfo.dept:''

              })
            }
            this.listPSM=newPSM
          })
          .catch(err => console.log(err))
        }
        else if(this.searchItem.length===0){
          this.currentPage=1
          request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
          .then(data => {
            this.totalPages=data.pages
            this.userInfo=data.userInfo
            let newPSM=[]
            for(let pm of data.psm){
              let res= getStatus(pm)
              newPSM.push({
                ...pm,
                ...res,
                empID:this.userInfo?this.userInfo.emNum:'',
                name:this.userInfo?this.userInfo.name:'',
                dept:this.userInfo?this.userInfo.dept:''

              })
            }
            this.listPSM=newPSM
            // console.log(this.listPSM)
            
          })
          .catch(err => console.log(err))
        }
      }
  
    },
    methods:{
      onChange: function () {
        if(this.searchItem.length==0){
          request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
          .then(data => {
            this.totalPages=data.pages
            this.userInfo=data.userInfo
            let newPSM=[]
            for(let pm of data.psm){
              let res= getStatus(pm)
              newPSM.push({
                ...pm,
                ...res,
                empID:this.userInfo?this.userInfo.emNum:'',
                name:this.userInfo?this.userInfo.name:'',
                dept:this.userInfo?this.userInfo.dept:''

              })
            }
            this.listPSM=newPSM
          })
          .catch(err => console.log(err))
        }
        else{
          request('post', `/pm-request/search/${this.currentPage}`,{query:this.searchItem,site:this.siteId})
          .then(data => {
            this.totalPages=data.pages
            this.userInfo=data.userInfo
            let newPSM=[]
            for(let pm of data.psm){
              let res= getStatus(pm)
              newPSM.push({
                ...pm,
                ...res,
                empID:this.userInfo?this.userInfo.emNum:'',
                name:this.userInfo?this.userInfo.name:'',
                dept:this.userInfo?this.userInfo.dept:''

              })
            }
            this.listPSM=newPSM
          })
          .catch(err => console.log(err))
        }
         
      },
      convertTime(time)
      {
          let dt = new Date(time)
          return `${
              (dt.getFullYear()).toString().padStart(4, '0')}-${
              (dt.getMonth()+1).toString().padStart(2, '0')}-${
              dt.getDate().toString().padStart(2, '0')} ${
              dt.getHours().toString().padStart(2, '0')}:${
              dt.getMinutes().toString().padStart(2, '0')}:${
              dt.getSeconds().toString().padStart(2, '0')}`
      },
      showAdd() {
        this.tempPSM = {}
        this.ao_selected={}
        this.item_selected={}
        this.list_ao_show = false
        this.list_item_show = false
        this.add_active=true
      },
      showUpdate(el){
        this.tempPSM = {
          ...el
        }
        this.ao_selected={}
        this.item_selected={}
        this.list_ao_show = false
        this.list_item_show = false
        if(this.tempPSM.ao1_id){
          let index = this.currentSiteAO.findIndex(el=>el._id===this.tempPSM.ao1_id)
          if(index>=0){
            this.ao_selected = this.currentSiteAO[index]
          }
        }
        if(this.tempPSM.item){
          let index = this.listItem.findIndex(el=>el._id===this.tempPSM.item)
          if(index>=0){
            this.item_selected = this.listItem[index]
            // this.tempPSM.inputData = el.psm_id.split('-')[1]
          }
        }
        
        // console.log(el)
  
        // this.bin_selected = {}
        // if (el.bin && el.bin._id) {
          
        //   for (let i = 0; i < this.bins.length; i++) {
        //     if (this.bins[i]._id == el.bin._id) {
        //       this.bin_selected = this.bins[i]
        //       break
        //     }
        //   }
        // }
        // } else {
        //   for (let i = 0; i < this.bins.length; i++) {
        //     if (this.bins[i]._id == el.bin) {
        //       this.bin_selected = this.bins[i]
        //       break
        //     }
        //   }
        // }
        
       
        this.update_active=true;
      },
      showDelete(el){
        this.tempPSM = el
        this.delete_active=true;
      },

      showStartJob(el){
        this.tempPSM=el
        this.startjob_active = true
      },
      showCancleJob(el){
        this.tempPSM=el
        this.canceljob_active = true
      },
      handleDeleteItem(){
        if(this.tempPSM.status!=='Draft'){
          return alert('Error!')
        }
        request('delete', `/pm-request/${this.tempPSM._id}`, {site: this.tempPSM.site})
        .then(() => {
          if(this.items.length===1 && this.currentPage>1)
          {
            this.currentPage=this.currentPage-1;
          }
          return request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
        })
        
        .then(data => {
          this.totalPages=data.pages
          let newPSM=[]
          for(let pm of data.psm){
            let res= getStatus(pm)
            newPSM.push({
              ...pm,
              ...res,
              empID:this.userInfo?this.userInfo.emNum:'',
              email:this.userInfo?this.userInfo.email:'',
              dept:this.userInfo?this.userInfo.dept:''

            })
          }
          this.listPSM=newPSM
          this.delete_active = false
          
        })
        .catch(err => console.log(err))
      },
      handleUpdateItem(){
        // console.log('bin selected:',this.bin_selected)
        // if (this.bin_selected) {
        //   this.tempPSM.bin = this.bin_selected._id
        // } else {
        //   this.tempPSM.bin = null
        // }
        if(this.tempPSM.status!=='Draft'){
          return alert('Error!')
        }
        this.tempPSM.site = this.siteId
  
        if (this.$refs.updatePSMForm.reportValidity()) {
          if(!this.ao_selected._id || !this.item_selected._id||!this.userInfo.email){
            return alert('Please fill all required information!')
          }
          let dt={
            _id:this.tempPSM._id,
            site:this.siteId,
            ao1:this.ao_selected._id,
            ao2:this.ao_selected.ao2_id,
            purpose:this.tempPSM.purpose,
            psm_id:this.item_selected.secureSN,
            source:this.tempPSM.source,
            destination:this.tempPSM.destination,
            file_transferred:this.tempPSM.file_transferred,
            item:this.item_selected._id
          }
          request('put', '/pm-request', dt)
            .then((res) => {
              if(res.code!=='000'){
                return alert(res.message)
              }
              request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
              .then(data => {
                this.totalPages=data.pages
                let newPSM=[]
                for(let pm of data.psm){
                  let res= getStatus(pm)
                  newPSM.push({
                    ...pm,
                    ...res,
                    empID:this.userInfo?this.userInfo.emNum:'',
                    email:this.userInfo?this.userInfo.email:'',
                    dept:this.userInfo?this.userInfo.dept:''

                  })
                }
                this.listPSM=newPSM
                this.update_active = false
              }) 
              .catch(err => {
                console.log(err)
                alert(err.message)
              })
              
            })
            .catch(err => {
              console.log(err)
              alert(err.message)
            })
        }
      },
      handleAddItem(){
        // if (this.bin_selected) {
        //   this.tempPSM.bin = this.bin_selected._id
        // }
        
        this.tempPSM.site = this.siteId
  
        if (this.$refs.addPSMForm.reportValidity()) {
          if(!this.ao_selected._id || !this.item_selected._id||!this.userInfo.email){
            return alert('Please fill all required information!')
          }
          let dt={
            employee:this.userInfo._id,
            site:this.siteId,
            ao1:this.ao_selected._id,
            ao2:this.ao_selected.ao2_id,
            purpose:this.tempPSM.purpose,
            psm_id:this.item_selected.secureSN,
            source:this.tempPSM.source,
            destination:this.tempPSM.destination,
            file_transferred:this.tempPSM.file_transferred,
            item:this.item_selected._id
          }
          request('post', '/pm-request', dt)
          .then((res) => {
            if(res.code!=='000'){
              return alert(res.message)
            }
            request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
            .then(data => {
              this.totalPages=data.pages
              let newPSM=[]
              for(let pm of data.psm){
                let res= getStatus(pm)
                newPSM.push({
                  ...pm,
                  ...res,
                  empID:this.userInfo?this.userInfo.emNum:'',
                  email:this.userInfo?this.userInfo.email:'',
                  dept:this.userInfo?this.userInfo.dept:''

                })
              }
              this.listPSM=newPSM
              this.add_active = false
              
            }) 
            .catch(err => {
              console.log(err)
              alert(err.message)
            })
          })
          
          .catch(err => {
            console.log(err)
            if(err.message==='Unauthorized'){
              return alert("Not allow to add psm request!")
            }
            alert(err.message)
          })
        }
      },
      handleChangeStatus(){
        // console.log('click!',el)
        this.loading = true
        request('post', '/pm-request/staff', {_id:this.tempPSM._id})
          .then(() => {
            return request('get', `/pm-request/list/${this.currentPage}/?site=${this.siteId}`)
            
            
          })
          .then(data => {
            this.totalPages=data.pages
            let newPSM=[]
            for(let pm of data.psm){
              let res= getStatus(pm)
              newPSM.push({
                ...pm,
                ...res,
                empID:this.userInfo?this.userInfo.emNum:'',
                email:this.userInfo?this.userInfo.email:'',
                dept:this.userInfo?this.userInfo.dept:''

              })
            }
            this.listPSM=newPSM
            this.startjob_active = false
            this.canceljob_active = false
            this.loading = false
          }) 
          .catch(err => {
            console.log(err)
            this.loading=false
            alert(err.message)
          })
      },
      handleStartClose(){
        if(!this.loading){
          this.startjob_active = false
        }
      },
      handleCancleClose(){
        if(!this.loading){
          this.canceljob_active = false
        }
      },
      selectAO(el){
        this.ao_selected = el
        this.list_ao_show = false
      },
      selectItem(el){
        this.item_selected = el
        this.list_item_show = false
      },

    },
  }
  </script>
  <style lang="scss">
  .sitePSM_container{

  }

  </style>